import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3ed5b976&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=3ed5b976&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed5b976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed5b976')) {
      api.createRecord('3ed5b976', component.options)
    } else {
      api.reload('3ed5b976', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=3ed5b976&scoped=true&", function () {
      api.rerender('3ed5b976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Alarm/List.vue"
export default component.exports